import { type LinearConfigurationUpdate } from "../../Linear/models";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type CsticUpdate } from "../../Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";
import * as CarriageCstic from "~/Configurators/Carriage/v2/configuration/CarriageCstics";
import { KmatType } from "~/Configurators/Linear/getKmatType";
import { getMainKmat } from "~/Configurators/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "../carriageConfiguratorConstants";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { transformUpdate } from "~/Configurators/Linear/linearDataTransformer";
import { isNonNull } from "~/utils/reducers";

export async function sendCarriageUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);

  // SCHAEFF-34261 - Reset AngularOrientation when lubrication connector is selected
  if (updatedCstics.some((cstic) => cstic.key === CarriageCstic.LubricationConnector)) {
    updatedCstics.push({
      key: CarriageCstic.LubricationConnectorAlignment,
      type: KmatType.CARRIAGE,
      index: 0,
      value: null,
    });
  }

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  const response = await sendCarriage({
    ...data,
    ...updateData,
  });

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transformUpdate(response, ConfiguratorType.Carriage, csticsToPreserve);
}
